exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#list-offline.list{padding-top:20px}#list-offline.list>div{height:45px;padding:10px;margin-bottom:10px;border-radius:5px;border:1px solid #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32b03bff","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/OfflineActions.vue
// module id = 708
// module chunks = 0